module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ui_title_line', {
    attrs: {
      "no_left": ""
    }
  }, [_vm._v("\n      КАК ЭТО РАБОТАЕТ\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "row pre-title"
  }, [_c('div', {
    staticClass: "col offset-2"
  }, [_c('ui_text', [_vm._v("\n          Найти адвоката и клиента стало гораздо легче\n        ")])], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row step-row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('p', {
    staticClass: "step"
  }, [_c('ui_sub_title_text', [_vm._v("Шаг 1")])], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('ui_text', [_vm._v("Адвокат заполняет анкету  в личном кабинете")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('p', {
    staticClass: "step"
  }, [_c('ui_sub_title_text', [_vm._v("Шаг 2")])], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('ui_text', [_vm._v("Клиент просматривает анкеты и выбирает подходящего адвоката")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('p', {
    staticClass: "step"
  }, [_c('ui_sub_title_text', [_vm._v("Шаг 3")])], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('ui_text', [_vm._v("Клиент создает обращение с адвокатом и обсуждает условия сделки")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('p', {
    staticClass: "step"
  }, [_c('ui_sub_title_text', [_vm._v("Шаг 4")])], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('ui_text', [_vm._v("По завершении заказа адвокат получает оговоренную сумму")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "offset-md-2 col padding-on-mobile"
  }, [_c('ui_title', [_vm._v("\n          ПРЕИМУЩЕСТВА\n        ")]), _vm._v(" "), _c('ui_text', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_vm._v("\n          Зарегистрируйтесь и начните выполнять заказы в удобное для вас время\n        ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "offset-md-1 col-md-10"
  }, [_c('div', {
    staticClass: "row advantage-row"
  }, [_c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/advantage_one.svg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "advantage"
  }, [_c('ui_sub_title_text', [_vm._v("Безопасный сервис")])], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('ui_text', [_vm._v("Выполняйте задания с безопасной сделкой: при успешном завершении работы вы гарантированно получите оплату на карту.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/advantage_two.svg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "advantage"
  }, [_c('ui_sub_title_text', [_vm._v("Свободный график")])], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('ui_text', [_vm._v("На сервисе “Мобильный адвокат” вы выполняете задания в удобное для вас время и устраиваете выходные, когда захотите.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/advantage_three.svg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "advantage"
  }, [_c('ui_sub_title_text', [_vm._v("Экономия на рекламе")])], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('ui_text', [_vm._v("Больше не нужно тратить деньги на собственный сайт и рекламу.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/advantage_four.svg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "advantage"
  }, [_c('ui_sub_title_text', [_vm._v("Достойный заработок")])], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('ui_text', [_vm._v("Зарабатывайте на заказах с “Мобильным адвокатом” без ограничений. Используйте сервис для подработки или начните развивать собственное дело.")])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "offset-md-2 col-md-8 button-wrapper"
  }, [_c('ui_btn', {
    on: {
      "click": _vm.reg
    }
  }, [_vm._v("Зарегистрироваться")])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row line"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/line_work.svg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c0a4eed","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Work/work.vue
// module id = 342
// module chunks = 2